/*
 Although these values seem arbitrary, they are defined by the designs of the
 component. In the case of the full size, the container takes into account
 space taken by thumbnail bar and overlay paddings.
 */
export const containerHeight = {
    small: '248px',
    medium: '280px',
    large: '392px',
    full: 'calc(100vh - 30.6rem)',
};
//# sourceMappingURL=constants.js.map